import * as React from 'react';

import Skeleton from 'react-loading-skeleton';

export const RewardsManagementSkeleton = () => {
  return <Skeleton width={'50px'} />;
};
